import React from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {Payment, approvePayment, PaymentStatus} from "../../resources/payment"
import Admonition from "../Admonitions/Admonition"
import Button from "../Button/Button"

interface ApprovePaymentModalProps {
	payment: Payment
	close: () => void
	onSuccess: () => void
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function ApprovePaymentModal({payment, close, onSuccess}: ApprovePaymentModalProps) {
	const accessToken = useAccessToken()
	const [state, approve] = useAsyncResultIdle(approvePayment)

	function OnPaymentSuccess({status}: {status: PaymentStatus}) {
		let message
		switch (status) {
			case PaymentStatus.Rejected:
				message = (
					<Admonition
						type={"is-danger"}
						title={"This payment cannot be approved"}
						message={"The amount exceeds hard limits of the account"}
					></Admonition>
				)
				break
			case PaymentStatus.Pending:
				message = <div>Payment was approved</div>
				break
			default:
				message = <div>Payment is in invalid status</div>
		}

		return (
			<div className={"modal-card-foot payment-success"}>
				<div className="payment-message">{message}</div>
				<Button theme={"neutral"} onClick={refreshAndClose(onSuccess, close)}>
					Close
				</Button>
			</div>
		)
	}

	return (
		<AsyncResultModal
			title="Approve Payment"
			close={refreshAndClose(onSuccess, close)}
			buttonClassname="is-success"
			classname="approve-payment-modal"
			state={state}
			buttonText="Approve"
			successComponent={(data) => <OnPaymentSuccess status={data.data.attributes.status} />}
			successText="Approved"
			onSubmit={() => approve(accessToken, payment.id)}
			errorToText={(err) => err.errors[0].title}
			disableCloseOnSuccess={true}
		>
			Are you sure?
		</AsyncResultModal>
	)
}
